/**
 * Website lockup in the OctoAIverse family: the octopus (as on octoaiverse.com,
 * octoreception.com and the tab icon), "OctoMail" in one colour, and the byline.
 * `tone="light"`: blue octopus + navy ink for the frosted header.
 * `tone="dark"`: white octopus + white type for the navy footer.
 * The portal keeps OctoLogo.
 */
export function SiteLogo({ tone }: { tone: "light" | "dark" }) {
  const light = tone === "light";
  return (
    <span className="inline-flex items-center gap-2.5">
      <img
        src={light ? "/brand/octopus-blue-96.png" : "/brand/octopus-white-96.png"}
        alt=""
        width={31}
        height={32}
        className="h-8 w-[31px] shrink-0"
      />
      <span className="flex flex-col justify-center">
        <span className={`text-lg font-semibold leading-none tracking-tight ${light ? "text-[#0e1726]" : "text-white"}`}>OctoMail</span>
        <span className={`mt-[3px] text-[10.5px] font-medium leading-none tracking-[0.01em] ${light ? "text-slate-500" : "text-slate-400"}`}>
          by OctoAIverse
        </span>
      </span>
    </span>
  );
}
